<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Prompt_Prompt-Heading">Week 2: My <span class="noBreak">Life</span><span class="noBreak"> </span><span class="noBreak">Story</span></p>
<div class="frame2">
<p class="Prompt_Prompt-copy _idGenParaOverride-1">In this exercise, I’m asking you to write your life story from the beginning, with your first memories. You can use your visual timeline as a guide to help you remember the most significant moments, but delve deeper into the story and really write about all the little nuances of life that we tend to take for granted. Expect to spend several hours on this exercise as it’s asking you to recapture your whole life story, and again, it’s up to you whether you want to break this exercise down into shorter periods or work through it all at once. Remember to capture as many images as you can, and project into the future to tell your life story as you hope it pans out over the next <span class="noBreak">few</span><span class="noBreak"> </span><span class="noBreak">years.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BlackAndResilient8.vue?2e4eced5